import { QueryKeys } from '../../../enums/queryKeys'

export const getImportedInvoiceQueryKey = (organizationId?: string, importedInvoiceId?: string) => [
  QueryKeys.ImportedInvoice,
  organizationId,
  importedInvoiceId,
]
